<template>
	<router-view :key="'community'+$route.path" />
</template>
<script>
	export default{
		mounted(){
			this.$store.state.breadcrumbs = {
				'title' : 'Vereniging',
				'links' : [
					{
						'title' : 'Vereniging',
						'href' 	: '/community'
					}
				],
			};

			let menus = [];
			if(this.$route.name != 'email') {
				menus.push({
					'title' : 'Leden',
					'href' 	: '/community/members',
					'children': [],
				})

				if(this.userHasPermissions(['Ledenadministratie'])) {
					menus.push({
						'title' : 'Oud Leden',
						'href' 	: '/community/members/inactive',
						'children': [],
					})
				}

				menus.push({
					'title' : 'Nieuws',
					'href' 	: '/community/news',
					'children': [],
				})

				menus.push({
					'title': 'Activiteiten',
					'href': '/community/events',
					'children': [],
				})

				menus.push({
					'title': 'Taken',
					'href': '/community/tasks',
					'children': [],
				})

				/* menus.push({
					'title' : 'Informatie',
					'href' 	: '/itemgroups',
					'children': [],
				}) */

				if(this.userHasPermissions(['Ledenadministratie'])) {
					menus.push({
						'title' : 'Ledenadministratie',
						'href' 	: '/community/members/administration',
						'children': [],
					})
				}
				
				if(this.userHasPermissions(['Ledenadministratie'])) {
					menus.push({
						'title' : 'Absentie',
						'href' 	: '/community/attendance',
						'children': [],
					})
				}
			}

			this.$store.state.inner_sidebar = menus

			if(this.$route.meta.Breadcrumb){
				this.$store.commit('addBreadcrumb', {
					'title' : this.$route.meta.Breadcrumb,
					'href'  : this.$route.path,
				});
			}
		}
	}
</script>
